(function () {
    angular.module('emarket.search').controller('SearchController', ['$state', function ($state) {
        var vm = this;
        vm.search = function () {
            $state.go('main.post.search', {
                q: vm.query
            });
        };
    }]);
}());
